<template>
  <b-card class="data-grid-box">
    <div class="row">
      <div id="session" class="col-lg-6 col-md-5 col-sm-4 col-xs-12">
        <h4 class="title1 fa-number">مدیریت محصولات</h4>
        <p class="subtitle">لیست تمامی محصولات شما</p>
      </div>
      <div class="col-lg-6 col-md-7 col-sm-8 col-xs-12">
        <nav-search :search="filters" />
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 search-box-session m-r-15"><div class="divider"></div></div>
      <div class="col-lg-3 col-md-3 col-sm-4 col-xs-12">
        <div class="box-filter">
          <ul>
            <li :class="{'active-item': filters.isActive == null}">
              <router-link :to="{ query: { filter: 'all' } }" replace>همه</router-link>
            </li>
            <li :class="{'active-item': filters.isActive == true}"><router-link :to="{ query: { filter: 'active' } }" replace>فعال</router-link></li>
            <li :class="{'active-item': filters.isActive == false}"><router-link :to="{ query: { filter: 'deactive' } }" replace>غیرفعال</router-link></li>
          </ul>
        </div>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-8 col-xs-9 m-b-19">
        <div class="float-left m-t-20">
          <div class="d-flex align-items-center">
            <b-button class="silver-btn" v-b-modal.modal-new>افزودن سریع</b-button>
            <button class="silver-btn m-r-5" @click="$refs.addProduct.openModal()">
              <i class="fa fa-plus-square"></i>
              ایجاد محصول جدید
            </button>
            <span v-b-modal.modal-center class="d-flex align-items-center cursor-pointer ml-3">
              <span class="flaticon2-plus mr-2"></span>
              <span class="font-size-lg">فیلتر</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <b-modal @ok="setFilters" ok-title="ثبت فیلتر" cancel-title="لغو" id="modal-center" centered title="فیلتر">
      <div class="">
        <label>عنوان</label>
        <b-form-input v-model="filters.title" placeholder="نام محصول"></b-form-input>
      </div>

      <div class="mt-2">
        <label>کد انبار</label>
        <b-form-input v-model="filters.sku" placeholder=""></b-form-input>
      </div>

      <div class="mt-2">
        <label>گروه محصول</label>
        <b-form-select v-model="filters.Groups" :options="groupOptions">
          <template #first>
            <b-form-select-option :value="null">-- یک گروه انتخاب کنید --</b-form-select-option>
          </template>
        </b-form-select>
      </div>

      <div class="mt-2">
        <label>نوع محصول</label>
        <b-form-select v-model="filters.productType" :options="productTypeOptions" />
      </div>

      <div class="mt-2">
        <label>وضعیت</label>
        <b-form-select v-model="filters.isActive" :options="isActiveOptions" />
      </div>

      <div class="mt-2">
        <label>موجودی</label>
        <b-form-select v-model="filters.InStock" :options="InStockOptions" />
      </div>
    </b-modal>

    <!-- <b-modal ok-title="ثبت ایجاد محصول" cancel-title="لغو" id="modal-new" centered title="لطفا نوع محصول را انتخاب کنید" @ok="$bvModal.show('new-confirm')">
      <div>
        <label v-for="(type, index) in productTypes" :key="index" class="w-100 my-8 d-block cursor-pointer">
          <input type="radio" name="productType" v-model="newProduct.type" :value="type.value" class="d-none" />
          <b-row>
            <b-col md="3" class="d-flex p-0 align-items-center justify-content-center">
              <component :class="[type.value === newProduct.type ? 'text-primary' : '']" :is="type.icon" scale="3" />
            </b-col>
            <b-col md="9" class="p-0">
              <h4>{{ type.title }}</h4>
              <h6>{{ type.subtitle }}</h6>
            </b-col>
          </b-row>
        </label>
      </div>
    </b-modal> -->

    <add-product ref="addProduct" />

    <list-table @fetchList="fetchList" @reload="reloadList" :loading="showLoading" />
  </b-card>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import "vue-advanced-cropper/dist/style.css"

import ListTable from "./ListTable"
// import HiModal from "@/view/components/HiModal.vue"
import AddProduct from "./AddProduct.vue"
import NavSearch from "./NavSearch.vue"

export default {
  name: "List",
  components: {
    ListTable,
    // HiModal,
    AddProduct,
    NavSearch
  },
  data() {
    return {
      showLoading: false,
      filters: {
        Groups: null,
        isActive: null,
        InStock: null,
        title: "",
        sku: "",
        productType: null
      },
      productTypeOptions: [
        {
          value: null,
          text: "-- نامشخص --"
        },
        {
          value: 0,
          text: "محصول فیزیکی ساده"
        },
        {
          value: 1,
          text: "محصول دیجیتالی و دانلودی"
        },
        {
          value: 2,
          text: "محصول به صورت پکیج"
        }
      ],
      isActiveOptions: [
        {
          value: null,
          text: "-- نامشخص --"
        },
        {
          value: true,
          text: "فعال"
        },
        {
          value: false,
          text: "غیر فعال"
        }
      ],
      InStockOptions: [
        {
          value: null,
          text: "-- نامشخص --"
        },
        {
          value: true,
          text: "موجود"
        },
        {
          value: false,
          text: "نا موجود"
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
      fields: "products/getFields",
      items: "products/getList",
      groupOptions: "productGroup/getListOption",
      productTypes: "products/getProductTypes",
      brands: "products/getBrandOptions"
    })
  },
  watch: {
    ["filters"]: {
      deep: true,
      handler(value) {
        // this.fetchList();
        console.log(value);
        this.setFilters()
      }
    },
    $route(to, from) {
      this.setActiveFilter(to.query)
    }
  },
  methods: {
    ...mapActions({
      list: "products/list",
      groupOptionsList: "productGroup/fetchAsOptionList",
      fetchBrands: "products/brandList"
    }),
    ...mapMutations({
      productFilter: "products/setFilter"
    }),

    fetchList() {
      this.showLoading = true;
      this.list()
      // this.groupOptionsList()
      this.fetchBrands()
      this.showLoading = false;
    },
    setFilters() {
      this.showLoading = true;
      this.productFilter(this.filters)
      // this.fetchList()
      this.reloadList()
      this.showLoading = false;
    },
    reloadList() {
      this.showLoading = true;
      var me = this;
      const scrollToTop = () => {
        const c = document.documentElement.scrollTop || document.body.scrollTop
        if (c > 0) {
          window.requestAnimationFrame(scrollToTop)
          window.scrollTo(0, c - c / 8)
        }
      }
      this.list().then(data => {
        if (data.data.status) {
          scrollToTop()
        }
      }).finally(() => {
        me.showLoading = false;
      })
    },
    setActiveFilter(query) {
      if(query.filter) {
        if(query.filter === "active") {
          this.filters.isActive = true
        } else if(query.filter === "deactive") {
          this.filters.isActive = false
        } else {
          this.filters.isActive = null
        }
      }
    }
  },
  mounted() {
    this.fetchList()
    this.setActiveFilter(this.$route.query)
  }
}
</script>

<style scoped>
.cropper {
  height: 300px;
  background: #ddd;
}
</style>